import { isNil } from 'lodash'
import { useState } from 'react'

import { GamOrderRetargetingDealsDeliveryDTO } from 'features/globalSetup/api/types/gamOrderRetargetingDealsDeliveryDTO'
import { GamOrderRetargetingDealsDelivery } from 'features/globalSetup/types/gamOrderRetargetingDealsDelivery'
import { WorkspaceDTO } from 'features/workspace'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

export type RetargetingFreshStatusAndError = Pick<
  GamOrderRetargetingDealsDelivery,
  'errorMessage' | 'status'
>

type Data = {
  node: null | {
    gamOrderRetargetingDealsDelivery: Pick<
      GamOrderRetargetingDealsDeliveryDTO,
      'errorMessage' | 'status'
    >
  }
}
type Variables = { workspaceId: WorkspaceDTO['id'] }

export const useGetFreshStatusAndErrorForGamRetargeting =
  (): null | RetargetingFreshStatusAndError => {
    const [result, setResult] = useState<null | RetargetingFreshStatusAndError>(null)
    const { workspaceId } = useWorkspaceParam()

    useQuery<Variables, Data>({
      onCompleted: async data => {
        if (isNil(data?.node?.gamOrderRetargetingDealsDelivery)) {
          return
        }

        const { errorMessage, status } = data.node.gamOrderRetargetingDealsDelivery
        setResult({
          errorMessage: errorMessage || undefined,
          status,
        })
      },
      options: {
        refetchInterval: DEFAULT_REFETCH_INTERVAL,
      },
      query: gql`
        query getFreshStatusAndErrorForGamRetargeting($workspaceId: ID!) {
          node(id: $workspaceId) {
            ... on Workspace {
              gamOrderRetargetingDealsDelivery {
                errorMessage
                status
              }
            }
          }
        }
      `,
      variables: { workspaceId },
    })

    return result
  }
